var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _line, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuava({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4A38B;}\n\t.st1{fill:#20A849;}\n\t.st2{fill:none;stroke:#9EC862;stroke-width:1.7515;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st3{fill:#60B565;}\n\t.st4{fill:#9EC862;stroke:#9EC862;stroke-width:4.5304;stroke-miterlimit:10;}\n\t.st5{fill:#9EC862;}\n\t.st6{fill:#ED677F;}\n\t.st7{fill:none;stroke:#9EC862;stroke-width:3.6243;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st8{fill:#F6B1AA;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.3,79.17c-0.68-1.65-0.45-3.52,0.63-4.88c1.26-1.59,3.23-1.94,4.57-1.73c1.32,0.2,1.58,0.88,2.83,1.26 c2.24,0.68,4.4-0.56,5.51-1.1c4.71-2.32,10.45-1.96,14.01-1.73c1.89,0.12,7.21,0.52,12.6,4.09c4.75,3.15,6.93,7.03,8.82,10.39 c0.3,0.54,1.26,2.29,1.57,4.72c0.18,1.41,0.37,2.88-0.47,3.78c-0.8,0.86-2.03,0.65-4.41,0.63c0,0-0.97-0.01-6.61,0.47 c-3.67,0.31-5.77,1.01-7.71,1.42c-8.51,1.77-16.76-1.55-17.95-2.05c-3.25-1.35-8.94-3.72-11.81-9.6 C108.81,82.65,108.44,80.61,108.3,79.17z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.32,72.78c0,0,4.13,1.54,10.8,3.9c6.67,2.36,21.25,7.38,26.57,8.8c5.31,1.42,7.5,1.89,7.5,1.89"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.28,78.87c0.56-1.69,0.19-3.54-0.99-4.82c-1.37-1.49-3.36-1.69-4.68-1.39c-1.3,0.3-1.51,0.99-2.73,1.46 c-2.18,0.85-4.43-0.23-5.58-0.69c-4.87-1.96-10.56-1.18-14.1-0.69c-1.87,0.26-7.15,1.05-12.26,5.01c-4.51,3.49-6.39,7.52-8.03,11.01 c-0.26,0.56-1.09,2.38-1.22,4.83c-0.08,1.42-0.16,2.9,0.75,3.73c0.86,0.8,2.07,0.49,4.44,0.3c0,0,0.97-0.08,6.63-0.02 c3.69,0.04,5.83,0.58,7.8,0.84c8.62,1.14,16.6-2.78,17.75-3.36c3.14-1.59,8.64-4.37,11.07-10.45 C101.03,82.37,101.25,80.31,101.28,78.87z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.2,74.19c0,0-13.02,6.32-22.85,10.21S61.04,91.2,61.04,91.2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104.71,83.58c-0.11-0.54-0.46-1.96-1.73-3.15c-0.15-0.14-1.8-1.59-4.09-1.57c-0.48,0-1.95,0.13-5.35,3.15 c-3.09,2.74-3.27,3.89-5.67,5.67c-1.84,1.37-3.29,1.85-4.88,2.52c-4.41,1.86-9.08,4.82-12.12,7.71c-5.63,5.36-7.29,12.04-7.71,13.85 c-0.52,2.21-1.67,7.39,0.16,13.7c1.86,6.42,5.89,10.38,8.03,12.44c1.8,1.73,3.49,2.97,4.72,3.78c1.56-0.56,2.89-0.73,3.78-0.79 c1.42-0.09,3.21-0.2,5.04,0.79c1.19,0.64,1.95,1.5,2.36,2.05c1.24,0.59,3.27,1.35,5.83,1.42c3.58,0.09,6.19-1.23,8.34-2.36 c5.58-2.92,8.73-7.12,9.6-8.34c5.26-7.38,5.28-15.25,5.2-17.63c-0.08-2.09-0.41-11.31-5.83-17c-1.19-1.26-2.97-2.7-3.62-5.35 c-0.55-2.24,0.13-3.65-0.47-6.61C105.9,85.95,105.21,84.49,104.71,83.58z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M129.28,148.23c0.46,0.68,5.38-0.97,9.9-4.69c4.09-3.37,6.18-7.05,6.6-7.82c4.62-8.35,3.28-16.8,2.78-19.98 c-1.12-7.06-4.1-11.96-5.39-13.9c-2.19-3.28-4.9-7.35-9.73-9.73c-0.32-0.16-3.79-1.86-7.65-4.34c-1.02-0.66-2.14-1.42-3.13-2.78 c-1.41-1.94-0.81-2.69-1.91-4c-1.93-2.3-5.88-2.49-8.51-1.74c-0.75,0.21-1.34,0.49-1.74,0.7c-0.51,0.49-1.31,1.14-2.43,1.56 c-1.45,0.54-2.26,0.26-3.3,0.52c-1.99,0.5-3.06,2.55-4,4.34c-1.6,3.05-1.09,4.36-2.43,8.34c-0.83,2.46-1.4,3.08-2.43,5.39 c-2.38,5.33-2.91,10.04-3.13,11.82c-0.39,3.22-0.9,7.36,0.35,12.51c0.36,1.47,2.04,7.88,7.65,13.73c4.24,4.42,8.72,6.42,11.12,7.47 c3.07,1.34,5.82,2.04,7.82,2.43c0.56-0.6,1.58-1.56,3.13-2.26c0.52-0.24,1.99-0.87,3.82-0.87c0.83,0,1.43,0.13,1.95,0.5 c0.18,0.13,0.59,0.41,0.78,0.91C129.77,147.25,129.08,147.94,129.28,148.23z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M129.28,148.23c0.46,0.68,5.38-0.97,9.9-4.69c4.09-3.37,6.18-7.05,6.6-7.82c4.62-8.35,3.28-16.8,2.78-19.98 c-1.12-7.06-4.1-11.96-5.39-13.9c-2.19-3.28-4.9-7.35-9.73-9.73c-0.32-0.16-3.79-1.86-7.65-4.34c-1.02-0.66-2.14-1.42-3.13-2.78 c-1.41-1.94-0.81-2.69-1.91-4c-1.93-2.3-5.88-2.49-8.51-1.74c-0.75,0.21-1.34,0.49-1.74,0.7c-0.51,0.49-1.31,1.14-2.43,1.56 c-1.45,0.54-2.26,0.26-3.3,0.52c-1.99,0.5-3.06,2.55-4,4.34c-1.6,3.05-1.09,4.36-2.43,8.34c-0.83,2.46-1.4,3.08-2.43,5.39 c-2.38,5.33-2.91,10.04-3.13,11.82c-0.39,3.22-0.9,7.36,0.35,12.51c0.36,1.47,2.04,7.88,7.65,13.73c4.24,4.42,8.72,6.42,11.12,7.47 c3.07,1.34,5.82,2.04,7.82,2.43c0.56-0.6,1.58-1.56,3.13-2.26c0.52-0.24,1.99-0.87,3.82-0.87c0.83,0,1.43,0.13,1.95,0.5 c0.18,0.13,0.59,0.41,0.78,0.91C129.77,147.25,129.08,147.94,129.28,148.23z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M128.48,144.98c0.42,0.61,4.88-0.88,8.97-4.25c3.7-3.05,5.6-6.39,5.98-7.08c4.19-7.56,2.97-15.22,2.52-18.11 c-1.01-6.4-3.71-10.84-4.88-12.6c-1.98-2.98-4.44-6.66-8.82-8.82c-0.29-0.14-3.44-1.68-6.93-3.94c-0.92-0.6-1.94-1.28-2.83-2.52 c-1.28-1.76-0.73-2.43-1.73-3.62c-1.75-2.08-5.33-2.25-7.71-1.57c-0.68,0.19-1.21,0.44-1.57,0.63c-0.46,0.45-1.19,1.04-2.2,1.42 c-1.31,0.49-2.05,0.23-2.99,0.47c-1.8,0.45-2.77,2.31-3.62,3.94c-1.45,2.77-0.99,3.95-2.2,7.56c-0.75,2.23-1.27,2.79-2.2,4.88 c-2.15,4.83-2.64,9.09-2.83,10.71c-0.36,2.92-0.82,6.67,0.31,11.34c0.32,1.33,1.85,7.14,6.93,12.44c3.84,4.01,7.9,5.82,10.08,6.77 c2.78,1.21,5.27,1.85,7.08,2.2c0.51-0.55,1.43-1.41,2.83-2.05c0.47-0.21,1.8-0.79,3.46-0.79c0.76,0,1.3,0.12,1.77,0.45 c0.16,0.11,0.53,0.37,0.71,0.83C128.92,144.09,128.3,144.71,128.48,144.98z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M76.45,140.18c0,0,2.44,7.01,3.54,7.64c1.1,0.63,4.72-2.2,5.35-2.68s2.28-2.44,2.28-2.44s-1.85-4.13-5.59-4.64 C78.3,137.54,76.45,140.18,76.45,140.18z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 101.92,
    y1: 69.07,
    x2: 108.68,
    y2: 82.08
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7863 -0.6178 0.6178 0.7863 -57.0551 92.4479)",
    className: "st8",
    cx: 105.12,
    cy: 128.71,
    rx: 1.83,
    ry: 1.59
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7863 -0.6178 0.6178 0.7863 -59.6696 96.5785)",
    className: "st8",
    cx: 109.78,
    cy: 134.55,
    rx: 1.83,
    ry: 1.59
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5609 -0.8279 0.8279 0.5609 -63.4007 155.4682)",
    className: "st8",
    cx: 114.86,
    cy: 137.5,
    rx: 1.83,
    ry: 1.59
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9865 -0.164 0.164 0.9865 -18.2842 18.5315)",
    className: "st8",
    cx: 103.07,
    cy: 119.98,
    rx: 1.83,
    ry: 1.09
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3276 -0.9448 0.9448 0.3276 -34.3682 172.1986)",
    className: "st8",
    cx: 103.8,
    cy: 110.25,
    rx: 1.09,
    ry: 1.83
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.248 -0.9688 0.9688 0.248 -13.4878 227.1916)",
    className: "st8",
    cx: 139.59,
    cy: 122.28,
    rx: 1.59,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.248 -0.9688 0.9688 0.248 -21.9276 230.7795)",
    className: "st8",
    cx: 137.68,
    cy: 129.51,
    rx: 1.59,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5311 -0.8473 0.8473 0.5311 -50.8244 176.682)",
    className: "st8",
    cx: 134.23,
    cy: 134.26,
    rx: 1.59,
    ry: 1.83
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9688 -0.248 0.248 0.9688 -23.8311 37.7536)",
    className: "st8",
    cx: 137.95,
    cy: 113.47,
    rx: 1.83,
    ry: 1.09
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7323 -0.681 0.681 0.7323 -35.71 118.8917)",
    className: "st8",
    cx: 133.35,
    cy: 104.86,
    rx: 1.83,
    ry: 1.09
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 118.84,
    cy: 129.39,
    rx: 1.69,
    ry: 1.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7888 -0.6146 0.6146 0.7888 -42.5278 98.4174)",
    className: "st8",
    cx: 121.95,
    cy: 111.09,
    rx: 1.69,
    ry: 1.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7714 -0.6363 0.6363 0.7714 -41.0668 99.129)",
    className: "st8",
    cx: 117.44,
    cy: 106.72,
    rx: 1.25,
    ry: 1.69
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.61 -0.7924 0.7924 0.61 -56.3951 155.6201)",
    className: "st8",
    cx: 129.9,
    cy: 135.1,
    rx: 1.69,
    ry: 1.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9761 -0.2172 0.2172 0.9761 -21.5731 30.9628)",
    className: "st8",
    cx: 130.06,
    cy: 113.61,
    rx: 1.69,
    ry: 1.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9639 -0.2663 0.2663 0.9639 -27.5745 39.5794)",
    className: "st8",
    cx: 132.18,
    cy: 121.48,
    rx: 1.69,
    ry: 1.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuava);
export default __webpack_public_path__ + "static/media/Guava.7e444b1e1162fbae3ed194a4873d25b7.svg";
export { ForwardRef as ReactComponent };